import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Universitat } from '../model/Universitat';
import { Pais } from '../model/pais';
import { Injectable } from '@angular/core';
import { Oferta } from '../model/oferta';

@Injectable()
export class BLUniversitat {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    list(pais: Pais): Promise<Universitat[]> {
        return new Promise<Universitat[]>((resolve, reject) => {
            this.http.get<Universitat[]>(this.dataService.getApiEndpoint('universitat?pais=' + pais.value)).subscribe(data => {
                resolve(data);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/lib/bl/bluniversitat.ts